import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, IncidentClient, Incident, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new IncidentClient(apiBaseUrl);

function useGetIncidentReport(id: number, role: AuthorizationRequestType) {
  return useQuery<Incident, ProblemDetails>({
    queryKey: [queryKeys.Incident.Get, { id }],
    queryFn: () => incidentClient.get(id, role),
    refetchOnMount: true,
  });
}

export default useGetIncidentReport;
